import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';
import { secondsToTimeDurationString } from '../';

export const totalWorkloadColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
  className = 'max-w-[20vw] w-[20vw]',
): TableColumn<T> => ({
  id: 'totalWorkload',
  label: <Trans i18nKey="workload_monthly" />,
  render: (value) => {
    return (
      <div className="overflow-hidden text-ellipsis">
        {secondsToTimeDurationString((value ?? 0) * 60)}
      </div>
    );
  },
  acessorKey: 'totalWorkload',
  sortable: false,
  className,
  ...options,
});
